import Api from '../Api'
import store from '@/store/store'

export default {
    getAllVehicles() {
        return Api().post('flette/listing', {
            userid: store.state.user._id
        })
    },

    createVehicle(vehicleData) {
        return Api().post('flette/add', {
            userid: store.state.user._id,
            ...vehicleData
        })
    },

    updateVehicle(id, vehicleData) {
        return Api().put('flette/update', {
            id,
            ...vehicleData
        })
    },

    deleteVehicle(id) {
        return Api().post('flette/delete', {
            id
        })
    }
}
